import React, { useState } from 'react';
import PropTypes from 'prop-types';
import s from './CorrectiveAction.module.scss';
import { FormattedMessage } from 'react-intl';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Activity from '../WSAControls/Activity/Activity';
import uuidv4 from 'uuid/v4';
import { initialCorrectiveActionsState } from '../../store/reducers/initialState';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import { compareValues } from '../../utils';

const CorrectiveActionComments = ({ correctiveAction, saveCorrectiveActionComment, UpdateAllowed, currentTimezone }) => {
  const [correctiveActionComment, setCorrectiveActionComment] = useState('');

  const commentChangeHandler = e => {
    setCorrectiveActionComment(e.target.value);
  };

  const commentSaveHandler = () => {
    if (correctiveActionComment.length > 0) {
      const comment = {
        CorrectiveActionId: correctiveAction.selectedCorrectiveAction.CorrectiveActionId,
        GuidIdentifier: uuidv4(),
        Description: correctiveActionComment
      };
      saveCorrectiveActionComment(comment);
      setCorrectiveActionComment('');
    }
  };

  const commentCancelHandler = () => {
    setCorrectiveActionComment('');
  };

  const comments = () => {
    let commentstData = correctiveAction.selectedCorrectiveAction.comments || [];

    if (commentstData && commentstData.length > 0) {
      commentstData = commentstData.map(comment => ({
        ...comment,
        ActivityDate: comment.CreatedDateTime,
        CreatedByName: comment.FullName,
        Id: comment.CorrectiveActionCommentId
      }));
    }

    return commentstData.sort(compareValues('ActivityDate', 'desc'));
  };

  const headertext = '';

  return (
    <div className={s.correctiveActionContent}>
      {correctiveAction.isLoading && <LoadingSpinner />}
      <Row className={s.breakrow}>
        <Col sm={12}>
          <h4>
            <FormattedMessage id="common.comments" defaultMessage="Comments" />
            <span data-unittest="correctiveActionCommentsCount" className={s.circle}>
              {correctiveAction.selectedCorrectiveAction.comments.length}
            </span>
          </h4>
        </Col>
      </Row>
      <Row className={s.breakrow}>
        <Col sm={12}>
          <Activity
            description={correctiveActionComment || ''}
            onActivityModified={commentChangeHandler}
            onSaveClick={commentSaveHandler}
            onCancelClick={commentCancelHandler}
            currentTimezone={currentTimezone}
            activities={comments()}
            isUpdateAllowed={UpdateAllowed}
            isViewAllowed={true}
            headingText={headertext}
          />
        </Col>
      </Row>
    </div>
  );
};

CorrectiveActionComments.defaultProps = {
  correctiveAction: {
    ...initialCorrectiveActionsState
  }
};

CorrectiveActionComments.propTypes = {
  correctiveAction: PropTypes.object.isRequired,
  saveCorrectiveActionComment: PropTypes.func.isRequired,
  currentTimezone: PropTypes.string.isRequired,
  UpdateAllowed: PropTypes.bool.isRequired
};

export default CorrectiveActionComments;
